import isTruthy from "@/lib/utils/boolean/isTruthy";

export default function (path?: string) {
  return [window.location.origin, path].filter(isTruthy).join("");
}
